export const BASE_URL = `${process.env.NEXT_PUBLIC_BASE_URL}`;

//login
export const SEND_PHONE_NUM = `${BASE_URL}/login/Verification`;
export const LOGIN = `${BASE_URL}/login/LoginProcess`;
export const CONFIRM = `${BASE_URL}/login/Confirm`;
export const SENDFAQ = `${BASE_URL}/board/write/process2`;

//test
export const END_PREV_TEST = `${BASE_URL}/login/PreCheckComplete`;
export const START_TEST = `${BASE_URL}/login/StartExam`;
export const END_TEST = `${BASE_URL}/login/EndExam`;
export const SEND_ID_CARD = `${BASE_URL}/login/SaveImage`;
export const SEND_AGREE = `${BASE_URL}/login/AgreeInfo`;
export const SEND_ATTEND = `${BASE_URL}/login/AttendanceCheck`;
export const SEND_CHEAT_MESSAGE = `${BASE_URL}/login/CheattingExam`;
export const SEND_WATCHED_VIDEO = `${BASE_URL}/login/whichUpdate`;

//time
export const SAVETIME = `${BASE_URL}/login/TimeSave`; //afterTime

//time table
export const GET_TIME_TABLE_RESULT = `${BASE_URL}/common/returnResult`;

//todo list
export const GET_TODO_LIST = `${BASE_URL}/common/returnTodoList`;

// mail data apis

export const MAIL_LIST_DATA = `${BASE_URL}/mail/inboxListLoad`; //all mail List
export const MAIL_TO_LIST_DATA = `${BASE_URL}/mail/sentboxListLoad`; // (sent) to mail List
export const MAIL_TEMP_DATA = `${BASE_URL}/mail/imsiBoxMailLoad`; // (save) imsi mail List

export const MAIL_VIEW_DATA = `${BASE_URL}/mail/inboxMailView`; //view-from mail
export const MAIL_VIEW_SENT_DATA = `${BASE_URL}/mail/sentboxMailView`; //view-to(sent) mail
export const MAIL_VIEW_TEMP_DATA = `${BASE_URL}/mail/imsiMailView`; //view-temp(imsi) mail

export const MAIL_SEND_DATA = `${BASE_URL}/mail/inboxMailSend`;
//send mail
export const MAIL_SEND_TEMP_DATA = `${BASE_URL}/mail/imsiboxMailSend`; //save mail(imsi)
export const MAIL_SEND_TEMP_SEND_DATA = `${BASE_URL}/mail/imsiMailSendBoxSend`; //send mail(imsi)
export const ALREADY_SEND_DATA = `${BASE_URL}/mail/mailCheck`;

export const ADDRESS_LIST_DATA = `${BASE_URL}/mail/addrLoad`;

//memo data apis
export const GET_MEMO_LIST = `${BASE_URL}/memo/MemoListLoad`;
export const CREATE_NEW_MEMO = `${BASE_URL}/memo/MemoInsert`;
export const MODIFY_MEMO = `${BASE_URL}/memo/MemoUpdate`;
export const DELETE_MEMO = `${BASE_URL}/memo/MemoDelete`;

// report data apis
export const GET_REPORT_LIST = `${BASE_URL}/report/ReportListLoad`;
export const CREATE_NEW_REPORT = `${BASE_URL}/report/ReportInsert`;
export const MODIFY_REPORT = `${BASE_URL}/report/ReportUpdate`;
export const SUBMIT_REPORT = `${BASE_URL}/report/ReportSend`;
export const TIMEOUT_REPORT_SEND = `${BASE_URL}/report/timeOutReportSend`;
export const GET_REPORT_EMPTY_USER = `${BASE_URL}/report/ReportSenderUser`;
export const SET_REPORT_EMPTY = `${BASE_URL}/report/PostReportSend`;
export const AUTO_SAVING = `${BASE_URL}/report/LiveReportSend`;

// messenger
export const GET_MESSENGER_ROOM_LIST = `${BASE_URL}/messenger/RoomListLoad`;
export const GET_MESSENGER_ROOM_DETAIL = `${BASE_URL}/messenger/Enter`;
export const SEND_MESSAGE = `${BASE_URL}/messenger/toInsert`;

//doc file list
export const GET_DOC_FILE_LIST_NO = `${BASE_URL}/document/docListEnter`;
export const GET_DOC_FILE_DETAIL = `${BASE_URL}/document/docContentsLoad`;
export const DOC_BOOKMARK = `${BASE_URL}/document/docFavorites`;
export const SEND_FOLDER_PW = `${BASE_URL}/document/hiddenFolderOpenYN `;

//admin
export const ADMIN_LOGIN = `${BASE_URL}/acghr/adminLogin`;
export const ADMIN_LOGIN_FIRST = `${BASE_URL}/acghr/adminLoginFirst`;

export const GET_ADMIN_QUESTION_LIST = `${BASE_URL}/upload/questionList`;
export const UPLOAD_IMG = `${BASE_URL}/upload/insertFile`;
export const INSERT_QUESTION = `${BASE_URL}/upload/insertQuestion`;
export const QUESTION_DELETE = `${BASE_URL}/upload/deleteQuestion`;
export const SELECT_QUESTION = `${BASE_URL}/upload/selectQuestion`;
export const UPDATE_QUESTION = `${BASE_URL}/upload/updateQuestion`;
export const ADMIN_ADDR_LOAD = `${BASE_URL}/mail/questAddrLoad`;

export const REPORT_DOC = `${BASE_URL}/externalAPI/reportInfo`;
export const RESULT_REPORT_DOC = `${BASE_URL}/externalAPI/resultReportInfo`;
export const RESULT_REPORT_DOC_LPT = `${BASE_URL}/externalAPI/resultReportInfo2`;

// register
export const REGISTER_USER = `${BASE_URL}/member/insertMember`;

//info
export const INFO_LIST = `${BASE_URL}/upload/selectInfo`;
export const INFO_DETAIL = `${BASE_URL}/upload/selectDetailInfo`;
export const INFO_UPDATE = `${BASE_URL}/upload/updateInfo`;
export const INFO_INTSERT = `${BASE_URL}/upload/insertInfo`;

//신규 추가 된 api (유프리즘 제외)
export const AWS_PRE_SIGNED_URL = `${BASE_URL}/externalAPI/aws/pre-signed-url`;
export const UPLOAD_IDCARD = `${BASE_URL}/other/exam/id`;
export const CHAT_DATA = `${BASE_URL}/other/chat/tester`;
export const UPLOAD_RECORD = `${BASE_URL}/other/exam/record`;
